(function () {
  'use strict';
  angular.module('vcutils.vcfields')
    .component('vcarea', {
      restrict: 'E',
      bindings: {
        model: '<',
        parentsave: '&',
        id: '@',
        placeholder: '@?',
        options: '<?'
      },
      template: `
           <textarea ng-model="vm.workingmodel" tabindex="0"
               ng-blur="vm.setCurrentFieldContent(vm.workingmodel)"
               ng-focus="vm.setCurrentField(vm.id)"
               ng-change="vm.setCurrentFieldContent(vm.workingmodel)"
               ng-class="{conflict: vm.dataconflict}"
               class="form-control" id="vm.id"
               ng-model-options="vm.options"
               >{{vm.placeholder}}</textarea>
      `,
      controllerAs: 'vm',
      controller: ['$log',
        function ($log) {
          let vm = this;

          // TODO: what are these supposed to do
          let lastmodel = undefined;
          let editing = undefined;
          let localcurrentvalue = undefined;
          
          vm.datachanged = false;
          vm.dataconflict = undefined;
          
          vm.save = save;
          vm.setCurrentField = setCurrentField;
          vm.setCurrentFieldContent = setCurrentFieldContent;
          
          vm.save = save;
          
          vm.$onInit = function () {
            vm.lastmodel = vm.model;
            vm.workingmodel = vm.model;
            
          };
          // TODO: looks weird, code review, riogous testing required
          vm.$onChanges = function (changes) {
            if (!changes.isFirstChange) {
              // if data did change compared to state before starting editing
              if (changes.model.currentValue !== vm.lastmodel) {
                vm.datachanged = true;
                // if editing is currently in progress -> merge content
                if (angular.isDefined(editing) && angular.isDefined(localcurrentvalue)) {
                  // $log.debug('debug: editing in progress: ', editing);
                  $log.debug('debug: data conflict: ', editing);
                  vm.dataconflict = true;
                  vm.lastmodel = changes.model.currentValue;
                  vm.workingmodel = changes.model.currentValue + ' ' + localcurrentvalue;
                }
                else {
                  // not currently editing -> override content
                  vm.workingmodel = vm.model;
                  vm.lastmodel = vm.model;
                }
              }
            }
          };
          
          function save() {
            if (vm.workingmodel !== vm.lastmodel) {
              editing = undefined;
              localcurrentvalue = undefined;
              vm.dataconflict = undefined;
              vm.lastmodel = vm.workingmodel;
              // $log.debug('debug: vcinput calling parentsave');
              vm.parentsave({key: vm.id, value: vm.workingmodel});
            }
          }
          
          
          function setCurrentField(fieldname) {
            editing = fieldname;
          }
          
          function setCurrentFieldContent(value) {
            localcurrentvalue = value;
            vm.save();
          }
          
          
        }] // controller
    }); // component

// klammerfriedhof
}());